// AUTO-GENERATED OPTIONS - DO NOT EDIT MANUALLY 
import {
  type AxiosRequestConfig,
} from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
  /**
   * show loading status
   */
  loading?: boolean;
  /**
   * display error message
   */
  showError?: boolean;
  /**
   * data security, extended fields are encrypted using the specified algorithm
   */
  security?: Record<string, 'md5' | 'sha1' | 'aes' | 'des'>;
  /**
   * indicates whether Authorization credentials are required for the request
   * @default true
   */
  withAuthorization?: boolean;

  errorInterceptor?: (
    response: { error: string; success: boolean; status: number; data: any },
    error?: string,
  ) => boolean | void;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

export interface IServiceOptions {
  axios?: any;
  /** only in axios interceptor config */
  loading: boolean;
  showError: boolean;
  /** Base path for API requests */
  basePath?: string;
}

// Default options with configurable base path
export const serviceOptions: IServiceOptions = {
  loading: true,
  showError: true,
  basePath: process.env.REACT_APP_API_BASE_PATH || ''
};

// Instance selector
export function axios(
  configs: IRequestConfig,
  resolve: (p: any) => void,
  reject: (p: any) => void,
): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then((res: any) => {
        resolve(res.data);
      })
      .catch((err: any) => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios');
  }
}

export function getConfigs(
  method: string,
  contentType: string,
  url: string,
  options: any
): IRequestConfig {
  // Build full URL with base path if url doesn't start with http
  const fullUrl = serviceOptions.basePath && !url.startsWith('http')
    ? serviceOptions.basePath.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url)
    : url;

  const configs: IRequestConfig = {
    loading: serviceOptions.loading,
    showError: serviceOptions.showError,
    ...options,
    method,
    url: fullUrl,
  };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType,
  };
  return configs;
}
